import React from 'react';

import { useEffect } from 'react';
import { useGroupActions } from './GroupContext';
import GroupLoader from './GroupLoader';
import GroupGrid from './GroupGrid';
import GroupModal from './GroupModal';
import CreateGroupsButton from './CreateGroupsButton';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';

import styles from './IndexGroup.module.scss';

const IndexGroup = ({ authenticatedUser }) => {
  const { initializeState } = useGroupActions();

  useEffect(() => {
    initializeState();
  }, []);

  return (
    <>
      <GroupLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Groups" />
          <CreateGroupsButton authenticatedUser={authenticatedUser} />
          <GroupGrid authenticatedUser={authenticatedUser} />
        </Stack>
      </div>
      <GroupModal />
    </>
  );
};

export default IndexGroup;
